import './index.css';

// Maybe too big
import 'core-js/index';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './App';
import { unregister } from './registerServiceWorker';

import { CommonConfig } from './common/config';
import { ServiceRegistry } from './services';

const global = (document.getElementById('global') as HTMLElement).dataset;
const config = JSON.parse(decodeURIComponent(global.config as string)) as CommonConfig;
const services = ServiceRegistry.create(config);

if (global.userPref) {
  services.currentUserService.cachePref(decodeURIComponent(global.userPref as string));
}

ReactDOM.render(<App config={config} services={services} />, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.tsx